<form [formGroup]="advisors" id="advisors" (ngSubmit)=onSubmit(advisors)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container"
		[ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" [(editQuestion)]="editQuestion"
			(editQuestionChange)="editQuestionChange($event)">

			<!--intro-->
			<question [qID]="'0'">
				<div>
					<h3>
						{{'ADVISORS.INTRO.OPENING1'|translate}}<br>
						{{'ADVISORS.INTRO.OPENING2'|translate}}<br>
						{{'ADVISORS.INTRO.OPENING3'|translate}}
					</h3>

					<div class="d-flex justify-content-center">
						<button type="submit" class="btn btn-primary m-valid">
							{{"COMMON.PROCEED"|translate}}
						</button>
					</div>
				</div>
			</question>

			<!--name-->
			<question [qID]="'1'">
				<div>
					<h3>
						{{'ADVISORS.INTRO.OPENING1'|translate}}<br>
						{{'ADVISORS.INTRO.OPENING2'|translate}}<br>
						{{'ADVISORS.INTRO.OPENING3'|translate}}<br><br>
					</h3>
					<h3>{{ 'ADVISORS.Q1.QUESTION' | translate }}</h3>
					<div class="d-flex flex-column flex-md-row justify-content-center text-center">
						<div class="mx-1 form-group">
							<input type="text" class="form-control m-form-control2"
								placeholder="{{ 'ADVISORS.Q1.INPUT1_PH' | translate }}" formControlName="firstName">
							<div class="form-text m-error"
								*ngIf="advisors.get('firstName').hasError('required') && submitted">
								{{ 'ADVISORS.Q1.REQUIRED1' | translate }}
							</div>
							<div class="form-text m-error"
								*ngIf="advisors.get('firstName').hasError('pattern') && submitted">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
						<div class="mx-1 form-group">
							<input type="text" class="form-control m-form-control2"
								placeholder="{{ 'ADVISORS.Q1.INPUT2_PH' | translate }}" formControlName="lastName">
							<div class="form-text m-error"
								*ngIf="advisors.get('lastName').hasError('required') && submitted">
								{{ 'ADVISORS.Q1.REQUIRED2' | translate }}
							</div>
							<div class="form-text m-error"
								*ngIf="advisors.get('lastName').hasError('pattern') && submitted">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-center">
						<button type="submit" class="btn btn-primary"
							[ngClass]="{'m-valid' : advisors.valid && qID=='1'}">
							{{"COMMON.PROCEED"|translate}}
						</button>
					</div>
				</div>
			</question>

			<!--tz-->
			<question [qID]="'2'">
				<div>
					<h3>{{"ADVISORS.Q2.QUESTION"|translate}}</h3>
					<div class="">
						<input class="form-control m-form-control" type="tel" maxlength="9"
							placeholder="{{'ADVISORS.Q2.PH1'|translate}}" formControlName="idNumber">
						<div>
							<div class="form-text m-error"
								*ngIf="advisors.get('idNumber').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="form-text m-error"
								*ngIf="advisors.get('idNumber').hasError('invalidId') && !advisors.get('idNumber').hasError('required') && submitted">
								{{ 'COMMON.ID_PATTERN_ERROR' | translate }}
							</div>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-center">
					<button type="submit" class="btn btn-primary"
						[ngClass]="{'m-valid' : advisors.valid && qID=='2'}">{{"COMMON.PROCEED"|translate}}</button>
				</div>
			</question>

			<!--phone-->
			<question [qID]="'3'">
				<div>
					<h3>{{"ADVISORS.Q3.QUESTION"|translate}}</h3>
					<inner-tooltip [qTitle]="'ADVISORS.Q3.TOOLTIP'|translate"
						[text]="'ADVISORS.Q3.TOOLTIP_TEXT'|translate" class="m-inner-popover"></inner-tooltip>
				</div>
				<div>
					<div class="d-flex justify-content-center">
						<div class="m-1">
							<phone-number [customClass]="'user-details'" formControlName="phoneNumber"
								[(isMobile)]="isMobilePhone" (change)="setValidatorsArray()"
								[attr.aria-label]="'HELP_DIALOG.PHONE_NUMBER_PC' | translate"
								[attr.aria-invalid]="!advisors.get('phoneNumber').valid &&  submitted">
							</phone-number>
							<div class="form-text m-error"
								*ngIf="advisors.get('phoneNumber').hasError('minlength') && submitted">
								{{ 'COMMON.PHONE_MIN_CHARS' | translate }}
							</div>
							<div class="form-text m-error"
								*ngIf="advisors.get('phoneNumber').hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="form-text m-error"
								*ngIf="advisors.get('phoneNumber').hasError('pattern') && submitted">
								{{ 'COMMON.PHONE_NUM_PATTERN_ERROR' | translate }}
							</div>
						</div>
					</div>
					<div class="d-flex justify-content-center">
						<button type="submit" class="btn btn-primary"
							[ngClass]="{'m-valid' : advisors.valid && qID=='3'}">{{"COMMON.PROCEED"|translate}}</button>
					</div>
				</div>
			</question>

			<!--email-->
			<question [qID]="'4'">
				<div>
					<h3>{{"ADVISORS.Q4.QUESTION"|translate}}</h3>
					<div class="form-group">
						<input type="text" formControlName="email" placeholder="{{'ADVISORS.Q4.PH1'|translate}}"
							class="form-control m-form-control" [attr.aria-label]="'ADVISORS.Q4.PH1'|translate" />
						<div class="form-text m-error" *ngIf="advisors.get('email').hasError('pattern') && submitted">
							{{ 'COMMON.EMAIL_PATTERN_ERROR' | translate }}
						</div>
						<div class="form-text m-error" *ngIf="advisors.get('email').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
					<div class="d-flex justify-content-center">
						<button type="submit" class="btn btn-primary"
							[ngClass]="{'m-valid' : advisors.valid && qID=='4'}">
							{{"COMMON.PROCEED"|translate}}
						</button>
					</div>
				</div>
			</question>

			<!--consulting Company-->
			<question [qID]="'5'">
				<div>
					<h3>{{"ADVISORS.Q5.QUESTION"|translate}}</h3>
					<div class="form-group">
						<input type="text" formControlName="consulting" placeholder="{{'ADVISORS.Q5.PH1'|translate}}"
							class="form-control m-form-control" [attr.aria-label]="'ADVISORS.Q5.PH1'|translate" />
						<div class="form-text m-error" *ngIf="advisors.get('consulting').hasError('required') && submitted">
							{{ 'COMMON.FIELD_REQUIRED' | translate }}
						</div>
					</div>
					<div class="d-flex justify-content-center">
						<button type="submit" class="btn btn-primary"
							[ngClass]="{'m-valid' : advisors.valid && qID=='5'}">
							{{"COMMON.PROCEED"|translate}}
						</button>
					</div>
				</div>
			</question>
			<!-- both: cycle propose-->
			<question [qID]="'6'">
					<h3>{{"ADVISORS.Q6.QUESTION"|translate}}
					</h3>
				<!-- <inner-tooltip [qTitle]="'CYCLE_DETAILS.Q1.TOOLTIP'|translate"
					[text]="'CYCLE_DETAILS.Q1.TOOLTIP_TEXT'|translate" class="m-inner-popover"></inner-tooltip> -->
				<div class="mt-4">
					<box-selector formControlName="consultingCompany" [options]="optionsConsultingCompany"
						[(selectedOption)]="selectedConsultingCompany" (optionClicked)="onSubmit(advisors)">
					</box-selector>
				</div>
			</question>

		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/advisors/advisors.component.html